import { getConfig } from '../../config';
const gtag = window.gtag;
if (!gtag) {
    console.error('google analytics script not loaded correctly, check index.html');
}
const GOOGLE_ANALYTICS_KEY = 'G-Q6ZV8RHQ9R';
export class AnalyticsProvider {
    setUserId(userId) {
        gtag('set', {
            'user_id': userId,
        });
        gtag('set', 'user_properties', {
            id: userId,
        });
    }

    setCurrentScreen(screenName, className) {
        gtag('config', GOOGLE_ANALYTICS_KEY, {
            'page_title' : screenName,
            'page_path': window.location.pathname,
            'page_location': window.location.href,
        });
    }

    logEvent(action, category, label) {
        if (action && typeof action === 'string') {
            action = action.replace(' ', '_');
        }
        gtag('event', action, {
            'event_category': category,
            'event_label': label,
        });
    }

    logEventWithParamaters(action, params) {
        const isProd = getConfig().isProductionEnvironment;
        if (!isProd) {
            params = {...params, debug_mode: 1};
        }
        gtag('event', action, params);
    }
}
